// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G10aFTDyy4bosZ2ffCZP{
    /* color: transparent; */
    background:  #66baff;
    border-radius: 10px;
    padding: 15px 0px 15px 0px;
    margin: 1% 0 1% 0 !important;
    justify-content: center;
    border: 3px solid black;
  }

  @media (max-width: 650px) {
    .G10aFTDyy4bosZ2ffCZP{
      border-radius: 10px;
      padding: 10px;
      margin-left: 15% !important;
      margin-right: 15% !important;
      margin-top: 10px;
      margin-bottom: 10px;
      justify-content: center;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Settings.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE;MACE,mBAAmB;MACnB,aAAa;MACb,2BAA2B;MAC3B,4BAA4B;MAC5B,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;IACzB;EACF","sourcesContent":[".contained{\n    /* color: transparent; */\n    background:  #66baff;\n    border-radius: 10px;\n    padding: 15px 0px 15px 0px;\n    margin: 1% 0 1% 0 !important;\n    justify-content: center;\n    border: 3px solid black;\n  }\n\n  @media (max-width: 650px) {\n    .contained{\n      border-radius: 10px;\n      padding: 10px;\n      margin-left: 15% !important;\n      margin-right: 15% !important;\n      margin-top: 10px;\n      margin-bottom: 10px;\n      justify-content: center;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contained": `G10aFTDyy4bosZ2ffCZP`
};
export default ___CSS_LOADER_EXPORT___;
